import useSWR from 'swr';
import { listChatMessagesApi, type WebChatMessage } from 'src/api/chat/Chat';
import type { Message } from '@/types/chat.types';

const fetcher = async (sessionId: string): Promise<Message[]> => {
  const result = await listChatMessagesApi({
    chatSessionId: sessionId,
    limit: 200,
  });

  return result.messages
    .filter((m) => m.kind === 'message' && m.bodyText)
    .map((m) => ({
      id: m.webChatMessageId,
      role: (m.direction === 'outbound' ? 'assistant' : 'user') as 'assistant' | 'user',
      content: m.bodyText ?? '',
      timestamp: new Date(m.createdAt),
    }));
};

export function useChatMessages(sessionId: string | null) {
  const { data, error, isLoading, mutate } = useSWR(
    sessionId ? ['chat-messages', sessionId] : null,
    () => fetcher(sessionId!),
  );

  const messages = data ?? [];

  return { messages, isLoading, error, mutate };
}
